import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import { Link } from 'react-router-dom';
import { BsFilePdfFill, BsCardChecklist  } from 'react-icons/bs';
import { AppContext } from '../AppContext';
import { Paginacion } from '../components/Paginacion';
import { CarreraConsulta } from '../components/CarreraConsulta';
import { Icon } from '../components/Icon';

import { EvaluacionDetalle } from '../components/EvaluacionDetalle';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const BASEURL = process.env.REACT_APP_API_URL;

const MySwal = withReactContent(Swal)

const dateOptions = {
    year: "2-digit",
    month: "numeric",
    day: "numeric",
};

const CarreraEvaluacion = (props) => {

    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const [state, setState] = useState({
        carrera: "",
        anio: "",
        termino: "",
        nombres: "",
        apellidos: "",
        page: 1,
        size: 10,
        carreras: [],
        carrerasLabel: [],
        anios: [],
        terminos: [],
    });

    const [paralelos, setParalelos] = useState([]);

    const currentUser = useContext(AppContext).currentUser;

    const populateInitialData = async (user) => {
        const carrerasRol = user.roles.filter(r => r.role === "COORDINADOR_CARRERA" || r.role === "COORDINADOR_GENERAL").map(r => r.scope);

        const carrerasEtiqueta = user.roles.filter(r => r.role === "COORDINADOR_CARRERA" || r.role === "COORDINADOR_GENERAL").map(r => r.scopeName);

        if (carrerasRol.length === 0) {
            setLoading(false);
            return;
        }

        const initialCarrera = props.match.params["carrera"] || carrerasRol[0]; // idPrograma

        const initialAnios = [];
        let initialPeriodos = [];

        const responsePeriodos = await fetch(`${BASEURL}/api/reporte-usuario/get-periodos-academicos`);
        const dataPeriodos = await responsePeriodos.json();

        initialPeriodos = [...initialPeriodos, ...dataPeriodos.datos];

        initialPeriodos.forEach(at => {
            if (!initialAnios.includes(at.anio)) {
                initialAnios.push(at.anio);
            }
        });

        const initialAnio = props.match.params["anio"] || (initialAnios.length > 0 ? initialAnios[0] : 0);
        const initialTerminos = [];

        initialPeriodos.filter(p => p.anio === initialAnio).forEach(at => {
            if (!initialTerminos.includes(at.termino)) {
                initialTerminos.push(at.termino);
            }
        });

        const initialTermino = props.match.params["termino"] || (initialTerminos.length > 0 ? initialTerminos[0] : "");
        const initialPage = props.match.params["page"] || state.page;
        const initialSize = props.match.params["size"] || state.size;

        MySwal.close();
        props.history.push(`/carrera-evaluacion/${initialCarrera}/${initialAnio}/${initialTermino}/${initialPage}/${initialSize}`);
        setState(prevState => ({
            ...prevState,
            carreras: carrerasRol,
            anios: initialAnios,
            terminos: initialTerminos,
            carrera: initialCarrera,
            carrerasLabel: carrerasEtiqueta,
            anio: initialAnio,
            termino: initialTermino
        }));
    };

    const populateData = async (user) => {
        const carrera = props.match.params["carrera"] || state.carrera;
        let anio = props.match.params["anio"] || state.anio;
        let termino = props.match.params["termino"] || state.termino;

        const page = parseInt(props.match.params["page"]) || state.page;
        const size = parseInt(props.match.params["size"]) || state.size;

        if (anio === 0 || carrera === "" || termino === "") return;

        const nombres = state.nombres;
        const apellidos = state.apellidos;

        let apiUrl = `${BASEURL}/api/reporte-usuario/planificacion-carrera-periodo/${carrera}/${anio}/${termino}/${page}/${size}`;
        if (nombres && nombres.trim() !== "") {
            apiUrl += `/${encodeURIComponent(nombres.trim())}`;
        }
        if (apellidos && apellidos.trim() !== "") {
            if (!nombres || nombres.trim() === "") apiUrl += `/${encodeURIComponent(" ")}`;
            apiUrl += `/${encodeURIComponent(apellidos.trim())}`;
        }

        const response = await fetch(apiUrl);
        const data = await response.json();

        setLoading(false);
        MySwal.close();
        if (data && data.total && data.datos) {
            setParalelos(data.datos.map(p => ({ ...p, verlista: false, verpdf: false, datapdf: "", estudiantes: [] })));
            setTotal(data.total);
        } else {
            setParalelos([]);
            setTotal(0);
        }
    };

    useEffect(() => {
        document.title = TITLE + " - Profesores de mi carrera";
        if (currentUser && currentUser !== undefined) {
            MySwal.fire({
                title: 'Cargando datos iniciales...',
                text: 'Espere un momento',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });
            populateInitialData(currentUser);
        }
    }, [currentUser]);

    useEffect(() => {
        if (currentUser && currentUser !== undefined) {
            setLoading(true);
            MySwal.fire({
                title: 'Cargando cursos...',
                text: 'Espere un momento',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });
            populateData(currentUser);
        }
    }, [state]);

    const handleInputChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const { carrera, anio, termino } = state;
        const page = 1;
        const size = 10;

        if (name === "carrera") {
            props.history.push(`/carrera-evaluacion/${value}/${anio}/${termino}/${page}/${size}`);
            setState(prevState => ({ ...prevState, carrera: value, nombres: "", apellidos: "", page, size }));
        } else if (name === "anio") {
            props.history.push(`/carrera-evaluacion/${carrera}/${value}/${termino}/${page}/${size}`);
            setState(prevState => ({ ...prevState, anio: value, nombres: "", apellidos: "", page, size }));
        } else if (name === "termino") {
            props.history.push(`/carrera-evaluacion/${carrera}/${anio}/${value}/${page}/${size}`);
            setState(prevState => ({ ...prevState, termino: value, nombres: "", apellidos: "", page, size }));
        }
    };

    const handleDocenteInput = (apellidos, nombres) => {
        const { carrera, anio, termino } = state;
        props.history.push(`/carrera-evaluacion/${carrera}/${anio}/${termino}/${1}/${10}`);
        setState({
            ...state,
            apellidos: apellidos == null ? "" : apellidos.trim(),
            nombres: nombres == null ? "" : nombres.trim(),
            page: 1, size: 10
        });
    };

    const handlePage = (url, page, size) => {
        props.history.push(`${url}/${page}/${size}`);
        setState(prevState => ({ ...prevState, page, size }));
    };

    const toggle = (paralelo) => {
        const i = paralelos.indexOf(paralelo);
        if (!paralelo.verlista && paralelo.estudiantes && paralelo.estudiantes.length === 0) {
            MySwal.fire({
                title: 'Cargando detalle...',
                text: 'Espere un momento',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });
            fetch(`${BASEURL}/api/reporte-usuario/planificacion-paralelo/${paralelo.anio}/${paralelo.termino}/${paralelo.codigo}/${paralelo.paralelo}/${paralelo.identificacion}`)
                .then(response => response.json())
                .then(data => {
                    MySwal.close();
                    setParalelos(prevParalelos => [
                        ...prevParalelos.slice(0, i),
                        {
                            ...prevParalelos[i],
                            verlista: !prevParalelos[i].verlista,
                            estudiantes: data.datos
                        },
                        ...prevParalelos.slice(i + 1)
                    ]);
                });
        } else {
            setParalelos(prevParalelos => [
                ...prevParalelos.slice(0, i),
                {
                    ...prevParalelos[i],
                    verlista: !prevParalelos[i].verlista,
                },
                ...prevParalelos.slice(i + 1)
            ]);
        }
    };

    const togglePDF = (paralelo) => {
        if (paralelo.evaluados == 0) {
            MySwal.fire({
                icon: 'info',
                title: 'Sin resultados',
                text: 'Este paralelo no ha sido evaluado',
            });
            return;
        }
        const i = paralelos.indexOf(paralelo);
        if (!paralelo.verpdf) {
            MySwal.fire({
                title: 'Generando PDF...',
                text: 'Espere un momento',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });
            fetch(`${BASEURL}/api/reporte-usuario/reporte-general-pdf/${paralelo.sistema}/${paralelo.idcurso}/${paralelo.idprofesor}`)
                .then(response => {
                    if (!response.ok) {
                        return response.text().then(text => {
                            throw new Error(text);
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    MySwal.close();
                    setParalelos(prevParalelos => [
                        ...prevParalelos.slice(0, i),
                        {
                            ...prevParalelos[i],
                            verpdf: !prevParalelos[i].verpdf,
                            datapdf: data
                        },
                        ...prevParalelos.slice(i + 1)
                    ]);
                })
                .catch(error => {
                    MySwal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `${error.message}`,
                    });
                });
        } else {
            setParalelos(prevParalelos => [
                ...prevParalelos.slice(0, i),
                {
                    ...prevParalelos[i],
                    verpdf: !prevParalelos[i].verpdf,
                },
                ...prevParalelos.slice(i + 1)
            ]);
        }
    };

    const renderTable = (paralelos) => {
        return (
            <>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th className="text-center">Año</th>
                            <th className="text-center">Término</th>
                            <th className="text-center">Código</th>
                            <th className="text-center">Materia</th>
                            <th className="text-center">Paralelo</th>
                            <th className="text-center">Docente</th>
                            <th className="text-center">
                                <span id="tt-pe">Periodo de evaluación</span>
                                <UncontrolledTooltip placement="top" target="tt-pe">
                                    {"día / mes / año"}
                                </UncontrolledTooltip>
                            </th>
                            <th className="text-center">% Respuestas</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paralelos.map((p, index) => {
                            const dtFechainicioevaluacion = new Date(p.inicioHetero);
                            const dtFechafinevaluacion = new Date(p.finHetero);
                            const porcentaje = p.registrados === 0 ? 0 : Math.round(p.evaluados * 100 / p.registrados);
                            return (
                                <tr key={index}>
                                    <td className="text-center">{p.anio}</td>
                                    <td className="text-center">{p.termino}</td>
                                    <td className="text-center">{p.codigo}</td>
                                    <td>{p.materia}</td>
                                    <td className="text-center">{p.paralelo}</td>
                                    <td>{p.docente}</td>
                                    <td>{dtFechainicioevaluacion.toLocaleString('es-EC', dateOptions)} - {dtFechafinevaluacion.toLocaleString('es-EC', dateOptions)}</td>
                                    <td className="text-center">
                                        <span id={"tt_" + index} >{porcentaje}%</span>
                                        <UncontrolledTooltip placement="bottom" target={"tt_" + index}>
                                            {p.evaluados}/{p.registrados}
                                        </UncontrolledTooltip>
                                    </td>
                                    <td className="text-center">
                                        <div className="btn-group" role="group" aria-label="Opciones" style={{ gap: "0.5rem" }}>

                                            <div>
                                            <span id={"ttb_checklist_" + index}>
                                                <Link className="btn btn-secondary btn-sm" to="#" onClick={() => toggle(p)}>
                                                    <Icon icon={<BsCardChecklist />} />
                                                </Link>
                                            </span>
                                            <UncontrolledTooltip placement="top" target={"ttb_checklist_" + index}>
                                                {"Detalle de evaluados"}
                                            </UncontrolledTooltip>
                                            <Modal isOpen={p.verlista} className="modal-md">
                                                <ModalHeader toggle={() => toggle(p)}>Lista de estudiantes</ModalHeader>
                                                <ModalBody>
                                                    <EvaluacionDetalle paralelo={p} estudiantes={p.estudiantes} />
                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button color="secondary" onClick={() => toggle(p)}>Cerrar</Button>
                                                </ModalFooter>
                                            </Modal>
                                            </div>

                                            <div>
                                            <span id={"ttb_pdf_" + index}>
                                                <Link className="btn btn-secondary btn-sm" to="#" onClick={() => togglePDF(p)}>
                                                    <Icon icon={<BsFilePdfFill />} />
                                                </Link>
                                            </span>
                                            <UncontrolledTooltip placement="top" target={"ttb_pdf_" + index}>
                                                {"Detalle en PDF"}
                                            </UncontrolledTooltip>
                                            <Modal isOpen={p.verpdf} className="modal-xl">
                                                <ModalHeader>Detalle Paralelo</ModalHeader>
                                                <ModalBody>
                                                    <embed src={`data:application/pdf;base64,${p.datapdf}`} width={1100} height={600} type='application/pdf' pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button color="secondary" onClick={() => togglePDF(p)}>Cerrar</Button>
                                                </ModalFooter>
                                            </Modal><br />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={8}>
                                <Paginacion total={total} page={state.page} size={state.size} url={`/carrera-evaluacion/${state.carrera}/${state.anio}/${state.termino}`} handle={handlePage} />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </>
        );
    };

    const contents = loading ? <p><em>Loading...</em></p> : renderTable(paralelos);

    return (
        <div>
            <h1 id="tabelLabel">Evaluación de mi carrera</h1>
            <CarreraConsulta
                carreraOptions={state.carreras}
                carrerasLabel={state.carrerasLabel}
                carreraValue={state.carrera}
                anioOptions={state.anios}
                anioValue={state.anio}
                terminoOptions={state.terminos}
                terminoValue={state.termino}
                onInputChange={handleInputChange}
                handleDocenteSubmit={handleDocenteInput}
            />
            {contents}
        </div>
    );
}

export default CarreraEvaluacion;
